import { HttpClient, HttpParams } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { ItemsResponse } from './items.models'
import { environment } from 'apps/gb-front/src/environments/environment'
import { GbFrontCookieService } from 'libs/gb-front/auth/util/src/lib/gb-front-cookie/gb-front-cookie.service'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'

@Injectable({
  providedIn: 'root',
})
export class ItemApiService extends GbBaseApiService {
  constructor(
    protected http: HttpClient,
    private gbFrontCookieService: GbFrontCookieService,
    @Inject(APP_CONFIG) protected appConfig: any,
  ) {
    super(http, appConfig)
  }

  /**
   * Fetch the API auction item list paginated
   * @param offset
   * @returns Observable<ItemsResponse>
   */
  getItems(urlName: string, offset: number, filters?: string): Observable<ItemsResponse> {
    const params = new HttpParams({
      fromString: filters || '',
    })
      .set('limit', environment.itemsPageSize)
      .set('offset', offset)

    const endPoint = `auctions/${urlName}/items/`

    let withCredentials = false
    if (this.gbFrontCookieService.isVolunteer()) {
      withCredentials = true
    }

    return this.get<ItemsResponse>(endPoint, {
      params: params,
      withCredentials: withCredentials,
    })
  }

  /**
   * Resyncs an item by its uuid
   */

  syncItem(urlName: string, itemUuid: string | undefined): Observable<ItemEntity> {
    let withCredentials = false

    if (this.gbFrontCookieService.isVolunteer()) {
      withCredentials = true
    }

    const params = new HttpParams({ fromObject: { expand: true } })
    return this.get<ItemEntity>(`auctions/${urlName}/items/${itemUuid}/`, {
      params: params,
      withCredentials: withCredentials,
    })
  }
}
